import {GetSaoLucasBills} from 'domain/usecases';
import {RemoteGetSaoLucasBills} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetSaoLucasBills = (): GetSaoLucasBills =>
	new RemoteGetSaoLucasBills(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.paymentsSaoLucas),
		makeAuthorizeHttpClientDecorator(),
	);
